import { spacingM } from './spacing';

export const pageWidth = '1600px';
export const pagePadding = spacingM;
